import {createComponent} from '../bridge/create-component';
import type {BridgeComponentOptions} from '../bridge/types';
import type {GetPaymentMethodsResponse} from '..';
import {getPaymentMethods} from '../api';
import {config} from '../config';
import {containerTemplate} from '../container';
import {validateComponentProps} from '../utils';
import {BizumModal} from './modal';
import type {BizumProps} from './types';

export * from './modal';
export * from './types';

const componentOptions: BridgeComponentOptions<BizumProps> = {
  tag: 'monei-bizum-button',
  url: config.bizumButtonUrl,
  dimensions: {
    width: '100%',
    height: 'auto'
  },
  autoResize: {
    width: false,
    height: true
  },
  aliases: {
    style: 'innerStyle'
  },
  computedProps: {
    __getConfig: {
      factory: ({props}) => getPaymentMethods.bind(null, props),
      type: 'function'
    },
    __onClick: {
      factory: ({props, state}) => {
        const rootNode = document.createElement('div');
        return ({amount, currency}: GetPaymentMethodsResponse) => {
          if (state.isOpen) return;
          let shouldOpen = true;
          if (props.onBeforeOpen) {
            shouldOpen = props.onBeforeOpen();
          }
          if (!shouldOpen) return;
          state.isOpen = true;
          if (!rootNode.parentNode) document.body.appendChild(rootNode);
          const bizumModal = new BizumModal({
            amount,
            currency,
            ...props,
            onClose: () => {
              state.isOpen = false;
              window.onpopstate = null;
              document.body.style.overflow = '';
            },
            isOpen: true
          } as any);
          window.history.pushState(null, '', window.location.href);
          window.onpopstate = () => bizumModal.updateProps({isOpen: false});
          Object.assign(document.body.style, {overflow: 'hidden'});
          return bizumModal.render(rootNode);
        };
      },
      type: 'function'
    }
  },
  validate: validateComponentProps,
  containerTemplate
};

export const Bizum = createComponent<BizumProps>(componentOptions);
